const { stripHtml } = require("string-strip-html");
const { stringLength } = require("simpul");
const storyCategory = require("./storyCategory");

function storyLength({ rich_text, count_chars, count_words }) {
  const text = rich_text && stripHtml(rich_text).result;

  const chars = count_chars || stringLength.char(text) || 0;

  const words = count_words || stringLength.word(text) || 0;

  const category = storyCategory(chars, words);

  return { chars, words, category };
}

module.exports = storyLength;
